import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface UnpaidInvoice {
  id: string;
  number: string | null;
  /** In cents, as Stripe returns it */
  amount_due: number;
  currency: string;
  created: number;
  due_date: number | null;
  hosted_invoice_url: string | null;
}

async function getUnpaidInvoices(
  companyId: string,
  auth: Authentication
): Promise<UnpaidInvoice[]> {
  try {
    const response = await HttpClient.get(
      `/leedflow/stripe/backoffice/unpaid-invoices?company_id=${encodeURIComponent(companyId)}`,
      auth.token
    );
    return response.data?.invoices ?? [];
  } catch (e: any) {
    console.error('getUnpaidInvoices error:', e);
    throw new GetUnpaidInvoicesFailure(e.message);
  }
}

export class GetUnpaidInvoicesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUnpaidInvoices;
